<template>
  <div class="expend-settings-detail">
    <a-descriptions title="基础信息" v-viewer bordered>
      <a-descriptions-item label="房屋信息">{{info.full_name}}</a-descriptions-item>
      <a-descriptions-item label="房屋户型">{{info.housing_type.name}}</a-descriptions-item>
      <a-descriptions-item label="房屋属性">{{info.houseTypeText}}</a-descriptions-item>
      <a-descriptions-item label="房屋状态">{{info.houseStatusText}}</a-descriptions-item>
    </a-descriptions>
    <a-row class="mg-normal">
      <a-col class="page-title">费项科目</a-col>
      <a-col>
        <a-space>
          <a-button type="primary" @click="newExpend()">费项设置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id" :pagination="false">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <a-button type="link" @click="editExpend(data)">编辑</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" v-model="modal.show" @ok="confirmModal" destroy-on-close width="40%" centered>
      <expend-settings-settings ref="expendSettingsSettings" :id="modal.id" :house="info"></expend-settings-settings>
    </a-modal>
  </div>
</template>

<script>
  import {
    houseTypeText,
    houseStatusText
  } from '@/io/dict.js';
  import BuildingService from '@/io/building.js';
  import ExpendService from '@/io/expend.js';
  import ExpendSettingsSettings from '@/views/community/expend_settings/Settings.vue';

  export default {
    name: 'ExpendSettingsDetail',
    props: {
      id: {
        type: Number,
        default() {
          return this.$route.params.id * 1;
        }
      },
    },
    data() {
      return {
        info: {
          housing_type: {}
        },
        table: {
          loading: false,
          data: [],
          columns: [
            {
              title: '费项科目',
              dataIndex: 'charges_name'
            },
            {
              title: '计费开始时间',
              dataIndex: 'start_date'
            },
            {
              title: '计费结束时间',
              dataIndex: 'end_date'
            },
            {
              title: '操作',
              scopedSlots: { customRender: 'action' },
            }
          ]
        },
        modal: {
          id: null,
          title: '费项设置',
          show: false
        }
      }
    },
    components: {
      ExpendSettingsSettings,
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initHouseInfo();
            this.initHouseExpendInfo();
          }
        },
        immediate: true
      }
    },
    methods: {
      newExpend() {
        this.modal.id = null;
        this.modal.show = true;
      },
      editExpend(data) {
        this.modal.id = data.id;
        this.modal.show = true;
      },
      confirmModal() {
        this.$refs.expendSettingsSettings.submit(() => {
          this.modal.show = false;
          this.initHouseExpendInfo();
        });
      },
      initHouseInfo() {
        BuildingService.houseInfo(this.id).then(res => {
          this.info = {
            ...res,
            housing_type: res.housing_type || {},
            houseTypeText: houseTypeText(res.house_state),
            houseStatusText: houseStatusText(res.state)
          };
        }).catch(err => {});
      },
      initHouseExpendInfo() {
        this.table.loading = true;
        ExpendService.houseExpendList(this.id).then(res => {
          this.table.data = res;
        }).catch(err => {}).finally(() => {
          this.table.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>